<!-- Main Toggles -->
<div class="main-toggles">
  <div>
    <mat-slide-toggle (change)="toggleDependencies()" [checked]="this.dependencyDrawingService.showDependencies">
      Show links
    </mat-slide-toggle>
  </div>
  <div>
    <div>
      <mat-slide-toggle (change)="toggleshowOnlyIssuesWithDeps()" [checked]="showOnlyIssuesWithDeps">
        Show only linked issues
      </mat-slide-toggle>
    </div>
  </div>
</div>

<mat-accordion [multi]="true">
  <!-- Filter Status -->
  <mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>Status Filter</mat-panel-title>
    </mat-expansion-panel-header>
    <div class="fwrap">
      <div *ngFor="let status of statuses" (click)="toggleStatusFilter(status.id)">
        <mat-icon *ngIf="(filteredStatuses.has(status.id))">visibility</mat-icon>
        <mat-icon *ngIf="(!filteredStatuses.has(status.id))">visibility_off</mat-icon>
        <span>{{status.name}}</span>
      </div>
    </div>
  </mat-expansion-panel>

  <!-- Filter Assignee -->
  <mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>Assignee Filter</mat-panel-title>
    </mat-expansion-panel-header>
    <div class="fwrap">
      <div *ngFor="let a of members | keyvalue" (click)="toggleAssigneeFilter(a.key)">
        <mat-icon *ngIf="(filteredAssignees.has(a.key))">visibility</mat-icon>
        <mat-icon *ngIf="(!filteredAssignees.has(a.key))">visibility_off</mat-icon>
        <span>{{a.value.displayName}}</span>
      </div>
    </div>
  </mat-expansion-panel>

  <!-- Filter IssueType -->
  <mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>Issue Type Filter</mat-panel-title>
    </mat-expansion-panel-header>
    <div class="fwrap">
      <div *ngFor="let i of issueTypes | keyvalue" (click)="toggleIssueTypeFilter(i.key);">
        <mat-icon *ngIf="(filteredTypes.has(i.key))">visibility</mat-icon>
        <mat-icon *ngIf="(!filteredTypes.has(i.key))">visibility_off</mat-icon>
        <span>{{i.value}}</span>
      </div>
    </div>
  </mat-expansion-panel>

  <!-- Filter Criticality -->
  <mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>Dependency / Issue Criticality Filter</mat-panel-title>
    </mat-expansion-panel-header>
    <div class="fwrap criticalityfilter">
      <div class="fwrap">
        <div *ngFor="let i of criticalities" (click)="toggleCriticalityFilter(i);">
          <mat-icon *ngIf="(filteredCriticality.has(i))">visibility</mat-icon>
          <mat-icon *ngIf="(!filteredCriticality.has(i))">visibility_off</mat-icon>
          <span>{{i}}</span>
        </div>
      </div>

      <div class="includeIssuesFilter">
        <mat-slide-toggle (change)="toggleCriticalityIncludeIssues()" [checked]="criticalityIncludeIssues">
          Hide issues as well
        </mat-slide-toggle>
      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion>

<div>
  <button class="resetButton" mat-raised-button color="accent" (click)="resetFilter()">Reset</button>
</div>